import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'
import { Media } from '../../../js/utils/const'
import { PriceModal } from '../../../js/components/PriceModal/scripts'

export default !function () {
  const block = document.querySelector('.tariffs-v6')

  if (!block) {
    return
  }

  const MatchMedia = {
    sm: window.matchMedia(`(max-width: ${Media.SM_MAX}px)`),
    md: window.matchMedia(`(min-width: ${Media.MD}px) and (max-width: ${Media.MD_MAX}px)`),
    lg: window.matchMedia(`(min-width: ${Media.LG}px)`)
  }

  const blockName = block.dataset.blockName || 'Блок без названия'
  const wrapper = block.querySelector('.tariffs-v6__wrapper')
  const listWrapper = block.querySelector('.tariffs-v6__list-wrapper')
  const items = block.querySelectorAll('.tariffs-v6__item')
  const subtitles = block.querySelectorAll('.tariffs-v6__subtitle-wrapper')
  const descriptions = block.querySelectorAll('.tariffs-v6__desc')
  const features = block.querySelectorAll('.tariffs-v6__features')

  const parseTariffData = (data) => {
    if (!data) {
      return null
    }

    try {
      const parsedTariffData = JSON.parse(data)

      return parsedTariffData && typeof parsedTariffData === 'object'
        ? parsedTariffData
        : null
    } catch {
      return null
    }
  }

  const showPriceModal = (data) => {
    const parsedTariffData = parseTariffData(data)

    if (!parsedTariffData) {
      return
    }

    const priceModalTemplate = document.querySelector('#price-modal')?.content
      .cloneNode(true)
      .querySelector('.price-modal__wrapper')

    if (!priceModalTemplate) {
      return
    }

    new PriceModal(priceModalTemplate, {
      blockName,
      tariffData: parsedTariffData
    }).init()
  }

  const showPriceModalHandler = (evt) => {
    const button = evt.target.closest('.tariffs-v6__button')

    if (!button) {
      return
    }

    const tariffData = button.closest('[data-tariff-data]')?.dataset?.tariffData

    showPriceModal(tariffData)
  }

  wrapper.addEventListener('click', showPriceModalHandler)

  const isMobile = () => MatchMedia.sm.matches

  const chevronClickHandler = (evt) => {
    const button = evt.target.closest('.tariffs-v6__button-chevron')

    if (!button) {
      return
    }

    const item = button.closest('.tariffs-v6__item')

    if (!item) {
      return
    }

    const featuresBlock = item.querySelector('.tariffs-v6__features')
    const featuresInner = item.querySelector('.tariffs-v6__features-inner')

    if (!featuresBlock || !featuresInner) {
      return
    }

    const isExpanded = item.classList.contains('tariffs-v6__item--expanding')

    if (isExpanded) {
      featuresBlock.style.height = '0'
      item.classList.remove('tariffs-v6__item--expanding')
      return
    }

    featuresBlock.style.height = `${featuresInner.scrollHeight}px`
    item.classList.add('tariffs-v6__item--expanding')
  }

  const changeViewMobile = () => {
    wrapper.removeEventListener('click', chevronClickHandler)

    if (!isMobile()) {
      features.forEach(feature => feature.removeAttribute('style'))
      items.forEach(item => item.classList.remove('tariffs-v6__item--expanding'))
      return
    }

    features.forEach(feature => {
      feature.style.height = 0
    })
    wrapper.addEventListener('click', chevronClickHandler)
  }

  const setHeight = (elements) => {
    if (!elements.length) {
      return
    }

    const heights = [...elements].map((element) => {
      element.removeAttribute('style')
      return element.clientHeight
    })
    const maxHeight = Math.max(...heights)

    elements.forEach((element) => {
      element.style.height = `${maxHeight}px`
    })
  }

  const updateElementsHeight = (elements) => {
    if (!isMobile()) {
      setHeight(elements)
      return
    }

    elements.forEach(element => element.removeAttribute('style'))
  }

  const updateTextHeights = () => {
    updateElementsHeight(subtitles)
    updateElementsHeight(descriptions)
  }

  const sliderInit = () => {
    const options = {
      wrapper: listWrapper,
      settings: {
        loop: false,
        autoScrollOffset: 1,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        slideClass: 'tariffs-v6__item',
        wrapperClass: 'tariffs-v6__list',
        spaceBetween: 8
      },
      initCondition: {
        sm: false,
        md: items.length > 2,
        lg: false,
        xl: false
      },
      createCallback: (slider) => {
        slider?.slideTo?.(1, 0)
        listWrapper.children[0].classList.remove('tariffs-v6__list--static')
      },
      destroyCallback: () => {
        listWrapper.children[0].classList.add('tariffs-v6__list--static')
      }
    }

    const slider = new Slider(options)
    slider.init()
    slider?.slider?.slideTo(1, 0)
  }

  sliderInit()
  changeViewMobile()
  updateTextHeights()

  MatchMedia.sm.addEventListener('change', changeViewMobile)
  MatchMedia.md.addEventListener('change', changeViewMobile)
  MatchMedia.lg.addEventListener('change', changeViewMobile)
  MatchMedia.sm.addEventListener('change', updateTextHeights)
  MatchMedia.md.addEventListener('change', updateTextHeights)
  MatchMedia.lg.addEventListener('change', updateTextHeights)
}()
